import { GetGroupRowAggParams } from 'ag-grid-community';
import { TableOverviewRowTuple } from 'src/domain';
import { weightedAverage } from './average-total.agg';

export type GrossMarginAggregation = Record<string, [number, number]>;
export const weightedAverageGrossMargin = (params: GetGroupRowAggParams<TableOverviewRowTuple>) => {
    const items = (params.nodes.map((n) => n.data).filter(Boolean) as TableOverviewRowTuple[]).map(
        (row) => row.columns
    );

    const fields = Object.keys(items[0] ?? {}).filter((f) => !f.endsWith('Id') && !f.endsWith('PlannedSplit'));

    const result = weightedAverage(items, fields, (item, field) => {
        const weight = item[`${field}PlannedSplit`];
        return [weight[0] / 100, typeof weight[1] === 'number' ? weight[1] / 100 : undefined];
    });

    return result as GrossMarginAggregation;
};
